import { type ReactNode } from 'react';

import { Box, colorOrToken, tokens } from '@cast/design-system';

const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

type AnimatedOverlayProps = {
  visible: boolean;
  children?: ReactNode;
  testId?: string;
  id?: string;
};

export const AnimatedOverlay = ({
  visible,
  children,
  testId = 'animated-overlay',
  id,
}: AnimatedOverlayProps) => {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      overflow="hidden"
      borderRadius={1}
      sx={{ pointerEvents: 'none' }}
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        p={24}
        sx={{
          bgcolor: colorOrToken(
            'rgba(5, 25, 34, 0.82)',
            tokens.theme.bg.structural.overlay
          ),
          backdropFilter: 'blur(4px)',
          borderRadius: 1,
          opacity: visible ? 1 : 0,
          visibility: visible ? 'visible' : 'hidden',
          transform: visible ? 'scale(1)' : 'scale(0.95)',
          transition: visible
            ? `opacity 0.5s ${EASING}, transform 0.5s ${EASING}, visibility 0s linear 0s`
            : `opacity 0.5s ${EASING}, transform 0.5s ${EASING}, visibility 0s linear 0.5s`,
          pointerEvents: visible ? 'auto' : 'none',
        }}
        data-testid={testId}
        id={id}
      >
        {children}
      </Box>
    </Box>
  );
};
